import pullAllBy from "lodash/pullAllBy";
import { getNotificationData } from "../notifications";
import { NotificationByCode } from "../types/notification";

export function addNotificationRemovingSameOnes(
  notifications: NotificationByCode[],
  notification: NotificationByCode
): void {
  removeNoAutoCloseNotificationsByCode(notifications, notification.code);
  notifications.push(notification);
}

export function removeNoAutoCloseNotificationsByCode(
  notifications: NotificationByCode[],
  code: string
): void {
  const notificationData = getNotificationData(code);
  if (notificationData.autoClose && code !== "KFW-002") {
    return;
  }
  pullAllBy(notifications, [{ code }], "code");
}
